import mainActions from "./mainActions"
import { getMyProfile } from "../login/loginOperations"
import openNotification from "../../components/_ui/notification"
import loginActions from "../login/loginActions"

export const mainInitialized = (navigate: any, msg: any) => (dispatch: any) => {
    let promGetMyProfile = dispatch(getMyProfile())

    Promise.all([
        promGetMyProfile, // Загрузка профиля оператора
    ]).then((result) => {
        let criticalErr: boolean = false

        switch (result[0]?.code) {
            case "ERR_NETWORK":
            case "ERR_UNEXPECTED":
            case "ERR_SERVER_AVAILABLE":
                criticalErr = true
                openNotification("Сервер не доступен...", msg.err_0001, "error", "bottomRight")
                break

            case "ERR_NOT_AUTHORIZED":
                criticalErr = true
                openNotification("Вы не авторизованы...", msg.err_0003, "error", "bottomRight")
                break
        }

        if (!criticalErr) {
            if (result[0]?.code === "NULL") { openNotification("Сервер не ответил...", msg.err_code, "error", "bottomRight") } // Сервер не ответил
            if (result[0]?.code === "ERR_QUERY_STRING") { openNotification("Ошибка в запросе...", msg.err_0010, "error", "bottomRight") } // Ошибка в запросе

            // if (result[1] === "NULL") { openNotification("Сервер не ответил...", msg.err_code, "error", "bottomRight") } // Сервер не ответил
            // if (result[1] === "ERR_QUERY") { openNotification("Ошибка в запросе...", msg.err_0008, "error", "bottomRight") } // Ошибка в запросе

            dispatch(mainActions.setMainAppInitialized(true))
        } else {
            navigate('/')

            localStorage.removeItem('token')
            dispatch(loginActions.setLogout())
        }
    })
}